/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StraightenIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Straighten',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="7" cy="11" r="1.3" />
    <circle cx="27" cy="11" r="1.3" />
    <circle cx="17" cy="5" r="1.3" />
    <circle cx="11" cy="7" r="1.3" />
    <circle cx="23" cy="7" r="1.3" />
    <path
      d="M6 14H.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5H6ZM33.5 14H28v12h5.5a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5ZM17 18c1.807 0 4.983-1 4.983-2.983L21.965 14H12v1.041C12 17 15.18 18 17 18Z"
    />
    <path d="M24.1 14v1c0 3-3.234 5.1-7.1 5.1S9.9 18 9.9 15v-1H8v12h18V14Z" />
  </svg>`;
};
